import React, { useContext, useState } from "react";

/* eslint-disable import/extensions */
import { DiscordRoles } from "../../../types/discord_roles";
import useGuildRoles from "./useGuildRoles";

interface RolesContextProps {
  guildRoles: DiscordRoles[] | null;
  setGuildRoles: React.Dispatch<React.SetStateAction<DiscordRoles[]>> | null;
  loadingRoles: boolean;
}

const RolesContext = React.createContext<RolesContextProps>({
  guildRoles: null,
  setGuildRoles: null,
  loadingRoles: true,
});

export function useDiscordRolesContext() {
  return useContext(RolesContext);
}

export function DiscordRolesProvider({ children }: any) {
  const guildId: string = localStorage.getItem("guild-id") || "";

  const {
    data: guildRoles,
    setGuildRoles,
    isLoading: loadingRoles,
  } = useGuildRoles(guildId);

  return (
    <RolesContext.Provider value={{ guildRoles, setGuildRoles, loadingRoles }}>
      {children}
    </RolesContext.Provider>
  );
}
